import { useEffect, useState } from "react";
import { getLoginUrl } from "../authConfig";

export default function AuthGate({ children }) {
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    // 🔥 Validar SOLO una vez
    const token = localStorage.getItem("idToken");

    // Permitir callback sin validar
    if (window.location.pathname === "/callback") {
      setChecking(false);
      return;
    }

    if (!token) {
      console.warn("⛔ No existe token — Redirigiendo al login");
      window.location.replace(getLoginUrl());
      return;
    }

    console.log("🔐 Token válido — acceso permitido");
    setChecking(false);
  }, []); // ⬅️ No depender del router NI de location

  if (checking) {
    return <div style={{ padding: 20 }}>Validando sesión...</div>;
  }

  return children;
}
